export const REGIONS = ['us', 'au', 'nz'];
